export enum RestType {
  GET = "get",
  POST = "post",
  PUT = "put",
  DELETE = "delete",
}
